import map from 'lodash.map';
import { avUserApi, avSpacesApi, avRegionsApi, avOrganizationsApi } from '@availity/api-axios';

export const getUser = () => avUserApi.me();

export const getSpacesApi = async (spaceId) => {
  const response = await avSpacesApi.get(spaceId, {});
  return response.data;
};

export const getCurrentRegions = () =>
  avRegionsApi.getCurrentRegion().then((response) => {
    const currentRegion = response.data.regions.map((region) => ({
      state: region.id,
    }));
    return { currentRegion };
  });

export const getOrganizationsApi = async () => {
  const response = await avOrganizationsApi.getOrganizations({});
  const organizations = map(response.data.organizations, (org) => ({
    id: org.id,
    name: org.name,
    customerId: org.customerId,
  }));
  return organizations;
};

export const getOrganizationsDetailsApi = async (organizationId) => {
  const response = await avOrganizationsApi.get(organizationId, {});
  const taxIds = response.data.taxIds.map((taxId) => ({
    id: taxId.number,
    value: taxId.number,
    type: taxId.type,
  }));
  return taxIds;
};
